module.exports = __webpack_public_path__ + "img/triangulo-naranja.69721310.svg";